export default __webpack_public_path__ + "assets/sounds/pop.ae826af32945571fe56683c4f1af43be.wav";